export interface Action<T = any, K extends keyof NonNullable<any> = any> {
    type: K;
    payload: T;
    rest: any[];
}

export type ActionCallback<K extends keyof any> = <T = any>(payload?: T, ...rest: any[]) => Action<T, K>;

export type ActionsMap<K extends keyof any> = {
    dispatch(type: K, payload: any, ...rest: any[]): void;
    mount(): void;
    unMount(): void;
} & { [P in K]: ActionCallback<K> };

export type ActionDispatch<T> = (type: T, payload: any, ...rest: any[]) => void;

/**
 * Getting first argument and rest arguments and create a partial action object from it
 * @param payload
 * @param rest
 */
export const actionPass = (payload: any, ...rest: any[]): any => ({ payload, rest });

export function createActions<T extends keyof any>(
    actions: string[],
): {
    [P in T]: ActionCallback<P>;
} {
    return actions.reduce((acc: any, key: string) => ({ ...acc, [key]: actionPass }), {});
}

export function mapActions<A extends keyof any>(actions: ActionsMap<A>, dispatch: ActionDispatch<A>): ActionsMap<A> {
    return Object.entries(actions).reduce(
        (acc: any, [key, actionFunc]) => ({
            ...acc,
            [key]: (payload$, ...rest$: any[]): void => {
                const { payload, rest } = (actionFunc as ActionCallback<A>)(payload$, ...rest$);
                dispatch(key as any, payload, ...rest);
            },
        }),
        {} as ActionsMap<A>,
    );
}
